const Commission = () =>
    import("@/views/commission/Commission");

const CommissionList = () =>
    import("@/views/commission/CommissionList");

const SquareCommission = () =>
    import("@/views/commission/SquareComission");

const LiquidationQuery = () =>
    import("@/views/commission/LiquidationQuery");

const Preliquidation = () =>
    import("@/views/commission/Preliquidation");

const PreliquidationApproval = () =>
    import("@/views/commission/PreliquidationApproval");

const PreliquidationQuery = () =>
    import("@/views/commission/PreliquidationQuery");    
    
    const LiquidationComission = () =>
    import("@/views/commission/LiquidationComission");    

export const CommissionListRoute = {
    path: "commissionList",
    component: CommissionList,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta",
                disabled: false,
                href: "#"
            }
        ],
        scope:['aps_broker']
    }
};

export const SquareCommissionListRoute = {
    path: "squareCommissionList",
    component: SquareCommission,
    meta: {
        // requiresAuth: true,
        title: "message.squareComission",       
        breadcrumb: [
            {
                text: "Reporte Cuadre Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta",
                disabled: false,
                href: "#"
            }
        ],
        // scope:['aps_broker']
    }
};

export const LiquidationQueryRoute = {
    path: "liquidationQuery",
    component: LiquidationQuery,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",        
        breadcrumb: [
        {
            text: "Comisiones",
            disabled: true,
            href: "#"
        },
        {
            text: "Consulta de liquidaciones",
            disabled: false,
            href: "#"
        }
        ],
        scope:['aps_broker']
    }
};

export const PreliquidationRoute = {
    path: "preliquidation",
    component: Preliquidation,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",        
        breadcrumb: [
        {
            text: "Comisiones",
            disabled: true,
            href: "#"
        },
        {
            text: "Preliquidación",
            disabled: false,
            href: "#"
        }
        ],
        scope:['aps_broker']
    }
};

export const PreliquidationApprovalRoute = {
    path: "preliquidationApproval",
    component: PreliquidationApproval,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
        {
            text: "Comisiones",
            disabled: true,
            href: "#"
        },
        {
            text: "Aprobación de preliquidaciones",
            disabled: false,
            href: "#"
        }
        ],
        scope:['aps_broker']
    }
};

export const LiquidationComissionRoute = {
    path: "liquidationComission",
    component: LiquidationComission,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
        {
            text: "Comisiones",
            disabled: true,
            href: "#"
        },
        {
            text: "Liquidación Consulta Comisiones",
            disabled: false,
            href: "#"
        }
        ],
        scope:['aps_broker']
    }
};


export const PreliquidationQueryRoute = {
    path: "preliquidationQuery",
    component: PreliquidationQuery,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
        {
            text: "Comisiones",
            disabled: true,
            href: "#"
        },
        {
            text: "Consulta Preliquidaciones",
            disabled: false,
            href: "#"
        }
        ],
        scope:['aps_broker']
    }
};


export const CommissionRoute = {
    path: "commission",
    component: Commission,
    children: [
        CommissionListRoute,
        SquareCommissionListRoute,
        LiquidationQueryRoute,
        PreliquidationRoute,
        PreliquidationApprovalRoute,
        PreliquidationQueryRoute,
        LiquidationComissionRoute
    ]
}